import i18n from "../infrastructure/I18n/i18n";

const keyPrefix = 'helpers.createDuplicateTitle';

export default function createDuplicateTitle(baseTitle: string, list: Array<{ title?: string | null }>) {
    const t = (key: string, params?: any) => i18n.t(`${keyPrefix}.${key}`, params) as string;

    const regex = new RegExp(`${baseTitle}( \\(${t('copy')}(?<number>( \\d+))?\\))`);

    const titleNumbersArr = [
        ...list
            .filter(n => n?.title)
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            .filter(n => n.title.startsWith(baseTitle))
            .map(n => {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
                const regexResult = regex.exec(n.title);
                if (!regexResult) {
                    return 0;
                }
                const number = regexResult?.groups?.number;
                return number ? Number(number) : 1;
            })
    ];

    const maxTitleNumber = titleNumbersArr.length === 0 ? 0 : Math.max(...titleNumbersArr);
    return `${baseTitle} (${t('copy')}${maxTitleNumber === 0 ? '' : ` ${maxTitleNumber + 1}`})`;
}
